﻿import { getUrlParams, removeValueFromCommaList, getUrlQueryString } from '../site.js';

(function ($) {
    // Autoexpand filters with elements in url parameter
    function autoExpandFilters() {
        var selected = $("input:checked");

        selected.each(function (i, el) {
            var $elem = $(el);
            var $topContainer = $elem.closest(".list-item.filter");
            var $filterContainer = $elem.closest(".form-group");
            var $header = $topContainer.find("a.header");

            var $topFilterContainer = $elem.closest(".content.collapse");
            var $subContentContainer = $filterContainer.find(".subcontent");

            if ($topFilterContainer.length > 0) {
                $header.toggleClass("collapsed");
                $header.attr("aria-expanded", "true");

                $topFilterContainer.removeAttr("style");
                $topFilterContainer.addClass("show");
                $topFilterContainer.attr("aria-expanded", "true");

                if ($subContentContainer.length > 0) {
                    $subContentContainer.css("display", "block");
                }
            }

        });
    }

    $(function () {
        // Only run in CourseListPage
        if (!$("._jsCourseList").length) {
            return;
        }

        var $checkboxes = $(":checkbox"),
            $courseListContainer = $("._jsCourseListContainer");

        var params = getUrlParams();

        autoExpandFilters();

        $checkboxes.on("change", function (e) { 
            var $el = $(this),
                checked = $el.prop("checked"),
                data = $el.data(),
                value = data.value,
                urlParameterName = data.urlParameter,
                urlParameterValue = params[urlParameterName],
                $parentContainer = $el.closest(".form-group");

            // Special case for haveStartupGuarantee because it is bool single value and not list
            if (urlParameterName === "startguarantee") {
                params[urlParameterName] = checked ? value : null;

                // Uncheck other checkbox if it is checked
                var $sibling = $parentContainer.siblings(".form-group");
                var $checkedSibling = $sibling.find("input:checked");
                if ($checkedSibling.length > 0) {
                    $checkedSibling.prop("checked", false);
                }
            }

            // Add url param
            else if (checked) {
                params[urlParameterName] = (urlParameterValue == null || urlParameterValue === "")
                    ? value
                    : urlParameterValue + "," + value;
            }
            // Remove url param if unchecked
            else {
                params[urlParameterName] = removeValueFromCommaList(urlParameterValue, value);
                var $childCheckBoxes = $parentContainer.find("input:checked");
                $childCheckBoxes.each(function (i, chkBox) {
                    var $checkBox = $(chkBox);
                    var subQueryStringName = $checkBox.data().urlParameter; 
                    params[subQueryStringName] = removeValueFromCommaList(params[subQueryStringName], $checkBox.data().value);
                    $checkBox.prop("checked", false);
                });
            }

            delete params.p;

            // Build new query-url
            var newUrlParams = getUrlQueryString(params);
            var url = "/api/CourseListSearch";

            // Do ajax post to server
            $.post(url, params, function (response) {
                // Update page with result
                $courseListContainer.html(response);

                // Use history api to update url
                window.history.pushState({}, "", window.location.href.split("?")[0] + newUrlParams);
            });
        });
    });
})(jQuery);